<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mZ9r9T/tc-custom/9780253044082.jpg?1713477554937" alt="This image is the cover for the book Jón Leifs and the Musical Invention of Iceland"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jón Leifs and the Musical Invention of Iceland
      </h1>
      <p class="bookDescription body article font2">
        <b>A study of the influential Icelandic composer’s career and his work.</b><br/><br/>In <i>Jón Leifs and the Musical Invention of Iceland</i>, Árni Heimir Ingólfsson provides a striking account of the dramatic career of Iceland’s iconic composer. Leifs (1899–1968) was the first Icelander to devote himself fully to composition at a time when a local music scene was only beginning to take form. He was a fervent nationalist in his art, fashioning an idiosyncratic and uncompromising “Icelandic” sound from traditions of vernacular music with the aim to legitimize Iceland as an independent, culturally empowered nation.<br/><br/>In addition to exploring Leifs’s career, Ingólfsson provides detailed descriptions of Leifs’s major works and their cultural contexts. Leifs’s music was inspired by the Icelandic landscape and includes auditory depictions of volcanos, geysers, and waterfalls. The raw quality of his orchestral music is frequently enhanced by an expansive percussion section, including anvils, stones, sirens, bells, ships’ chains, shotguns, and cannons.<br/><br/>Largely neglected in his own lifetime, Leifs’s music has been rediscovered in recent years and hailed as a singular and deeply original contribution to twentieth-century music. <i>Jón Leifs and the Musical Invention of Iceland</i> enriches our understanding and appreciation of Leifs and his music by exploring the political, literary and environmental contexts that influenced his work.<br/><br/><b>“Composers of fearsome originality seldom have an easy path in the world. Jón Leifs, who translated the landscapes and legends of Iceland into sound, comes vividly to life in this brilliant, panoramic biography, his myriad personal and political conflicts delineated with clarity and candor. A major twentieth-century figure at last receives his due.” —Alex Ross, music critic for <i>The New Yorker </i>and author of<i> The Rest Is Noise</i></b><br/><br/><b>“Jón Leifs was the first major Icelandic composer and it is insane that most of his pieces were not performed or recorded until recently. His works were almost just a myth to us Icelanders and therefore this book is so magnificently important. . . . This book is incredibly well written and Árni Heimir’s analysis of the music is deeply satisfying. I listened to each work as it was being discussed, which turned the experience from black and white to color! An extraordinary achievement!” —Björk, singer/songwriter</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Árni Heimir Ingólfsson
      </h2>
      
      <p class="authorDescription body article"><P><P>Árni Heimir Ingólfsson is Artistic Advisor of the Iceland Symphony Orchestra and Visiting Professor at the Iceland Academy of the Arts. He is the author of <I>Jón Leifs—Líf í tónum</I>,<I></I>which was nominated for the Icelandic Book Award.</P></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2593d9be